<template>
  <div class="star">
    <svg
      class="star__inner"
      v-if="is12"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        :fill="fill"
        :stroke="stroke"
        stroke-width="1"
        d="M4.94289 3.89211L6 0.638464L7.0571 3.89211C7.18268 4.27863 7.54287 4.54032 7.94928 4.54032H11.3705L8.60264 6.55119C8.27382 6.79008 8.13624 7.21353 8.26186 7.60007L9.31925 10.8537L6.55137 8.84284C6.22259 8.60398 5.7774 8.60398 5.44863 8.84285L2.68075 10.8537L3.73814 7.60007C3.86376 7.21353 3.72617 6.79008 3.39736 6.55119L0.629494 4.54032H4.05072C4.45713 4.54032 4.81731 4.27863 4.94289 3.89211Z"
      />
    </svg>

    <svg
      class="star__inner"
      v-if="is24"
      width="24" height="23"
      viewBox="0 0 24 23" fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        :fill="fill"
        :stroke="stroke"
        stroke-width="2"
        d="M9.88579 7.78421L12 1.27693L14.1142 7.78421C14.3654 8.55725 15.0857 9.08064 15.8986 9.08064H22.741L17.2053 13.1024C16.5476 13.5802 16.2725 14.4271 16.5237 15.2001L18.6385 21.7075L13.1027 17.6857C12.4452 17.208 11.5548 17.208 10.8973 17.6857L5.3615 21.7075L7.47628 15.2001C7.72751 14.4271 7.45235 13.5802 6.79472 13.1024L1.25899 9.08064H8.10144C8.91426 9.08064 9.63463 8.55725 9.88579 7.78421Z"
      />
    </svg>

    <svg
      class="star__inner"
      v-if="is32"
      width="32" height="31"
      viewBox="0 0 32 31" fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        :fill="fill"
        :stroke="stroke"
        stroke-width="2"
        d="M15.84 1.11624C15.8586 1.05892 15.8823 1.03861 15.8977 1.02813C15.9194 1.01331 15.9549 1 16 1C16.0451 1 16.0806 1.01331 16.1023 1.02813C16.1177 1.03861 16.1414 1.05892 16.16 1.11624L19.136 10.2759C19.4262 11.1693 20.2587 11.7742 21.1981 11.7742H30.8295C30.8898 11.7742 30.9165 11.7905 30.9312 11.8018C30.952 11.8179 30.9756 11.8475 30.9895 11.8904C31.0035 11.9333 31.0018 11.9712 30.9944 11.9964C30.9892 12.0143 30.9772 12.0431 30.9284 12.0785L23.1363 17.7395C22.3763 18.2917 22.0583 19.2704 22.3486 20.1638L25.3254 29.3236C25.344 29.3809 25.3368 29.4113 25.3305 29.4288C25.3217 29.4535 25.3008 29.4851 25.2643 29.5117C25.2278 29.5382 25.1913 29.5482 25.165 29.549C25.1464 29.5496 25.1153 29.5471 25.0666 29.5117L17.2744 23.8506C16.5145 23.2985 15.4855 23.2985 14.7256 23.8506L6.93343 29.5117C6.88468 29.5471 6.85356 29.5496 6.83497 29.549C6.80867 29.5482 6.77217 29.5382 6.73568 29.5117C6.69918 29.4851 6.67834 29.4535 6.66946 29.4288C6.66318 29.4113 6.65595 29.3809 6.67458 29.3236L9.65136 20.1638C9.9417 19.2704 9.6237 18.2917 8.86371 17.7395L1.07159 12.0785C1.02283 12.0431 1.01083 12.0143 1.00562 11.9964C0.998241 11.9712 0.996532 11.9333 1.01047 11.8904C1.02441 11.8475 1.04802 11.8179 1.06883 11.8018C1.08355 11.7905 1.11019 11.7742 1.17045 11.7742H10.8019C11.7413 11.7742 12.5738 11.1693 12.864 10.2759L15.84 1.11624Z"
      />
    </svg>

    <svg
      class="star__inner"
      v-if="is48"
      width="48" height="48"
      viewBox="0 0 48 48" fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        :fill="fill"
        :stroke="stroke"
        stroke-width="2"
        d="M23.2845 1.51986C23.5097 0.826711 24.4903 0.826717 24.7155 1.51986L29.1795 15.2594C29.5479 16.3935 30.6047 17.1613 31.7971 17.1613H46.2443C46.9731 17.1613 47.2761 18.0939 46.6865 18.5223L34.9983 27.0138C34.0336 27.7147 33.6299 28.9571 33.9985 30.0912L38.4636 43.8308C38.6889 44.524 37.8956 45.1004 37.306 44.672L25.6177 36.1804C24.6531 35.4796 23.3469 35.4796 22.3823 36.1804L10.694 44.672C10.1044 45.1004 9.31109 44.524 9.53635 43.8308L14.0015 30.0912C14.3701 28.9571 13.9664 27.7147 13.0017 27.0138L1.31349 18.5223C0.723862 18.0939 1.02689 17.1613 1.75568 17.1613H16.2029C17.3953 17.1613 18.4521 16.3935 18.8205 15.2594L17.8695 14.9504L18.8205 15.2594L23.2845 1.51986Z"
      />
    </svg>

    <svg
      class="star__inner"
      v-if="is52"
      width="52" height="50"
      viewBox="0 0 52 50" fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        :fill="fill"
        :stroke="stroke"
        stroke-width="2"
        d="M25.1456 1.62076C25.4145 0.793078 26.5855 0.79308 26.8544 1.62076L31.6904 16.5053C32.0784 17.6995 33.1912 18.5081 34.4469 18.5081H50.098C50.9683 18.5081 51.3301 19.6217 50.626 20.1332L37.9638 29.3324C36.9479 30.0704 36.5228 31.3788 36.9109 32.573L41.7482 47.4577C42.0172 48.2853 41.0699 48.9736 40.3658 48.4621L27.7036 39.2629C26.6877 38.5249 25.3123 38.5249 24.2964 39.2629L11.6342 48.4621C10.9301 48.9736 9.98281 48.2853 10.2518 47.4577L15.0891 32.573C15.4772 31.3788 15.0521 30.0704 14.0362 29.3324L1.37397 20.1332C0.669893 19.6217 1.03173 18.5081 1.90199 18.5081H17.5531C18.8088 18.5081 19.9216 17.6995 20.3096 16.5053L25.1456 1.62076Z"
      />
    </svg>

    <svg
      class="star__inner"
      v-if="is56"
      width="56" height="54"
      viewBox="0 0 56 54" fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        :fill="fill"
        :stroke="stroke"
        stroke-width="2"
        d="M27.0067 1.72167C27.3194 0.759442 28.6806 0.759446 28.9933 1.72167L34.2012 17.7512C34.6088 19.0055 35.7777 19.8548 37.0966 19.8548H53.9517C54.9634 19.8548 55.3841 21.1495 54.5656 21.7441L40.9293 31.6509C39.8622 32.4262 39.4157 33.8005 39.8234 35.0549L45.0328 51.0845C45.3455 52.0467 44.2442 52.8469 43.4257 52.2522L29.7894 42.3453C28.7224 41.5701 27.2776 41.5701 26.2106 42.3453L12.5743 52.2522C11.7558 52.8469 10.6545 52.0467 10.9672 51.0845L16.1766 35.0549C16.5843 33.8005 16.1378 32.4262 15.0707 31.6509L1.43445 21.7442C0.615922 21.1495 1.03658 19.8548 2.0483 19.8548H18.9034C20.2223 19.8548 21.3912 19.0055 21.7988 17.7512L27.0067 1.72167Z"
      />
    </svg>

    <svg
      class="star__inner"
      v-if="is42"
      width="43" height="41"
      viewBox="0 0 43 41" fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        :fill="fill"
        :stroke="stroke"
        stroke-width="2"
        d="M20.9928 1.3685C21.1524 0.877166 21.8476 0.877167 22.0072 1.3685L25.9132 13.3906C26.2523 14.4344 27.225 15.1411 28.3225 15.1411H40.9638C41.4804 15.1411 41.6952 15.8022 41.2772 16.1059L31.0501 23.5359C30.1621 24.1811 29.7906 25.3246 30.1298 26.3684L34.0368 38.3906C34.1965 38.8819 33.6341 39.2905 33.2162 38.9869L22.989 31.5567C22.1011 30.9117 20.8989 30.9117 20.011 31.5567L9.78381 38.9869C9.36585 39.2905 8.80351 38.8819 8.96319 38.3906L12.8702 26.3684C13.2094 25.3246 12.8379 24.1811 11.9499 23.5359L1.72278 16.1059C1.30482 15.8022 1.51962 15.1411 2.03622 15.1411H14.6775C15.775 15.1411 16.7477 14.4344 17.0868 13.3906L20.9928 1.3685Z"
      />
    </svg>
  </div>
</template>

<script>
const BLUE = '#1A82CB';
const WHITE = '#FFFFFF';
const GRAY = '#E0E0E0';
const RED = '#F34744';

const SIZE_56 = '56';
const SIZE_52 = '52';
const SIZE_48 = '48';
const SIZE_42 = '42';
const SIZE_32 = '32';
const SIZE_24 = '24';
const SIZE_12 = '12';

export default {
  name: "star",

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: SIZE_24,
    },
    errorMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    fill() {
      return this.active ? BLUE : WHITE;
    },
    stroke() {
      if (this.errorMode) {
        return RED;
      }

      return this.active ? BLUE : GRAY;
    },
    is56() {
      return this.size === SIZE_56;
    },
    is52() {
      return this.size === SIZE_52;
    },
    is48() {
      return this.size === SIZE_48;
    },
    is42() {
      return this.size === SIZE_42;
    },
    is32() {
      return this.size === SIZE_32;
    },
    is24() {
      return this.size === SIZE_24;
    },
    is12() {
      return this.size === SIZE_12;
    },
  }
}
</script>

<style lang="scss">
  .star {
    font-size: 0;
  }
</style>